/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateGcpIamCredentialRequestBody = {
  /**
   * The ID of the credential to update.
   */
  id: string;
  /**
   * The service account in your project that Speakeasy impersonates. Grant Speakeasy's own service account roles/iam.serviceAccountTokenCreator on it — see externalCredentials.getGcpSetupInfo.
   */
  impersonateServiceAccount: string;
  /**
   * A human-readable name for the credential.
   */
  name: string;
};

/** @internal */
export type UpdateGcpIamCredentialRequestBody$Outbound = {
  id: string;
  impersonate_service_account: string;
  name: string;
};

/** @internal */
export const UpdateGcpIamCredentialRequestBody$outboundSchema: z.ZodMiniType<
  UpdateGcpIamCredentialRequestBody$Outbound,
  UpdateGcpIamCredentialRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    impersonateServiceAccount: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      impersonateServiceAccount: "impersonate_service_account",
    });
  }),
);

export function updateGcpIamCredentialRequestBodyToJSON(
  updateGcpIamCredentialRequestBody: UpdateGcpIamCredentialRequestBody,
): string {
  return JSON.stringify(
    UpdateGcpIamCredentialRequestBody$outboundSchema.parse(
      updateGcpIamCredentialRequestBody,
    ),
  );
}
